const closeButtonIconSvg =
  '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M19.707 4.293a.999.999 0 0 0-1.414 0L12 10.586 5.707 4.293a.999.999 0 1 0-1.414 1.414L10.586 12l-6.293 6.293a.999.999 0 1 0 1.414 1.414L12 13.414l6.293 6.293a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414L13.414 12l6.293-6.293a.999.999 0 0 0 0-1.414" fill-rule="evenodd"/></svg>';

/**
 * Creates the <button> element for the close button and adds the provided callback to the
 * click event for the button.
 *
 * @param onClick The callback when the close button is clicked.
 * @returns The created <button> element for the close button
 */
export function closeButton(onClick: () => void) {
  const parser = new DOMParser();
  const closeButton = document.createElement("button");
  const closeButtonClasses = [
    "button-control",
    "button-close",
    "floor-adhesion-close-button",
  ];
  const closeButtonIconElement = parser.parseFromString(
    closeButtonIconSvg,
    "image/svg+xml",
  ).documentElement;
  closeButton.appendChild(closeButtonIconElement);
  closeButton.classList.add(...closeButtonClasses);

  closeButton.addEventListener("click", onClick);

  return closeButton;
}
